(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amielle-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amielle-product-reviews')) {
    customElements.define('amielle-product-reviews', class extends HTMLElement {
      connectedCallback() {
        this.disconnect?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.disconnect = new AbortController();
        this.removeAttribute('data-enhanced');
        document.dispatchEvent(new CustomEvent('amielle:reviews:change'));
        if (this.dataset.source === 'vitals') {
          const mount = this.querySelector('#bundle-product_reviews');
          const heading = this.querySelector('.amielle-reviews__header');
          if (!mount) return;
          const sync = () => {
            const ready = Boolean(mount.textContent.trim());
            this.toggleAttribute('data-ready', ready);
            if (heading) heading.hidden = !ready && !this.hasAttribute('data-design-mode');
          };
          this.observer = new MutationObserver(sync);
          this.observer.observe(mount, { childList: true, subtree: true, characterData: true });
          sync();
          return;
        }
        this.cards = [...this.querySelectorAll('[data-review]')];
        this.list = this.querySelector('.amielle-reviews__list');
        this.navigation = this.querySelector('.amielle-reviews__navigation');
        this.previous = this.querySelector('[data-review-previous]');
        this.next = this.querySelector('[data-review-next]');
        if (!this.list || !this.cards.length) return;
        this.cards.forEach(card => { card.hidden = false; });
        this.setAttribute('data-enhanced', '');
        this.syncNavigation();
        this.previous?.addEventListener('click', () => this.navigate(-1), { signal: this.disconnect.signal });
        this.next?.addEventListener('click', () => this.navigate(1), { signal: this.disconnect.signal });
        this.list.addEventListener('scroll', () => this.syncNavigation(), { passive: true, signal: this.disconnect.signal });
        this.list.addEventListener('keydown', event => {
          if (event.target !== this.list || this.dataset.scrollReviews !== 'true' || this.hasAttribute('data-design-mode')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.navigate(event.key === 'ArrowLeft' ? -1 : 1);
          }
        }, { signal: this.disconnect.signal });
        this.resizeObserver = new ResizeObserver(() => this.syncNavigation());
        this.resizeObserver.observe(this.list);

      }
      navigate(direction) {
        const step = this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.list).gap) || 16);
        this.list.scrollBy({ left: step * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      syncNavigation() {
        if (!this.navigation || !this.previous || !this.next) return;
        const maximum = this.list.scrollWidth - this.list.clientWidth;
        this.navigation.hidden = this.dataset.scrollReviews !== 'true' || this.hasAttribute('data-design-mode') || maximum <= 1;
        this.previous.disabled = this.list.scrollLeft <= 1;
        this.next.disabled = this.list.scrollLeft >= maximum - 1;
      }
      disconnectedCallback() { this.disconnect?.abort(); this.observer?.disconnect(); this.resizeObserver?.disconnect(); document.dispatchEvent(new CustomEvent('amielle:reviews:change')); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
